import * as yup from 'yup';

import { REQUIRED } from '../forms/errorsText.js';

export const validationFields = {
  afterDate: yup.string().required(REQUIRED),
  beforeDate: yup.string().required(REQUIRED),
  storeIdEq: yup.string(),
  byUser: yup.string(),
  nameCont: yup.string(),
  withCashbacks: yup.string(),
  byLocation: yup.string().required(REQUIRED),
  stateEq: yup.string(),
  byMerchantNames: yup.string(),
  nameNotIContAll: yup.string(),
  refundStatusEq: yup.string(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (searchParams) => {
  const { q } = searchParams;

  return q;
};
